export const focusElement = {
    inserted(el: any){
        const childData = el.querySelectorAll("input")[0];

        if(childData)
            childData.focus();
    }
}